import { AggregationTranslation } from '@/types/virtual-search/filters';
import { DataTableHeader } from 'vuetify';
import { CfsTableHeaders } from '@/store/modules/components/useCfsTableStore';
import { FileExportOptionType } from '@/constants/file-export';

export const formatAdditionalTableHeaders = (
  translations: AggregationTranslation,
  defaultHeaders: DataTableHeader[]
): DataTableHeader[] => {
  const mappedTranslatedHeaders = Object.values(translations).map((item) => ({
    text: item.label,
    value: item.value.replace('.keyword', ''),
    header: item?.header,
    active: false,
    selected: false,
  }));
  return mappedTranslatedHeaders.filter(
    (header) =>
      !defaultHeaders.find(
        (h: DataTableHeader) => h.value === header.header || h.value === header.value
      )
  );
};

export const formatExportHeaders = (headers: CfsTableHeaders[]) => {
  const activeHeaders = headers.filter((h) => h.active && h.value !== 'actions');
  return activeHeaders.reduce<FileExportOptionType>(
    (acc, cur) => {
      acc.headers.push(cur.text);
      acc.fields.push(cur?.exportHeader ?? cur.value);
      return acc;
    },
    {
      headers: [],
      fields: [],
    }
  );
};
